import { useCallback, useEffect } from "react";

export const useActiveTab = (setActiveTab: React.Dispatch<React.SetStateAction<number>>) => {
  const handleHashChange = useCallback((e: HashChangeEvent) => {
    const newUrl = e.newURL;
    const hash: string = newUrl.substring(newUrl.indexOf("#") + 1);
    if (hash.includes("subscription")) {
      setActiveTab(1);
    }
  }, []);
  useEffect(() => {
    window.addEventListener("hashchange", handleHashChange);
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);
};
